// istanbul ignore file

import styled from 'styled-components';
import { AnalyticsWrapper } from '@cld/analytics';

export const StyledApplicationLayout = styled.div<{ isMobile?: boolean }>`
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};

  /* The hack for Safari, see https://bugs.webkit.org/show_bug.cgi?id=141832 */
  @supports (-webkit-touch-callout: none) {
    height: var(--inner-height);
  }
`;

export const StyleApplicationWrapper = styled.div`
  flex: 1;
  overflow: auto;
  z-index: 0;
`;

export const StyledSideMenuAnalyticsWrapper = styled(AnalyticsWrapper)`
  z-index: 1;
`;

export const StyledPrimaryMenuAnalyticsWrapper = styled(AnalyticsWrapper)`
  z-index: 2;
`;
